export const KEYCLOAK_CONFIG = {
  url: import.meta.env.VITE_KEYCLOAK_CONFIG_URL,
  realm: import.meta.env.VITE_KEYCLOAK_CONFIG_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CONFIG_CLIENT_ID,
  clientSecret: import.meta.env.VITE_KEYCLOAK_CONFIG_CLIENT_SECRET,
};

export const KeycloakRequestBaseURL = `${KEYCLOAK_CONFIG.url}/realms/${KEYCLOAK_CONFIG.realm}/protocol/openid-connect/`;
